// Breadcrumbs to top

const homepageTemplate = document.querySelector('.template-index');
const collectionTemplate = document.querySelector('.template-collection');
const productTemplate = document.querySelector('.template-product');
const athleteTemplate = document.querySelector('.template-athlete');
const pageTemplate = document.querySelector('.template-page');
const searchTemplate = document.querySelector('.template-search');
const breadcrumb = document.querySelector('.breadcrumbs-container');
const siteMain = document.querySelector('#site-main');
const collectionTop = document.querySelector('#collection-top');
const astarsShortcut = document.querySelector('.astars-outfitter-shortcut');
const astarsObject = JSON.parse(sessionStorage.getItem('as-outfitter'));

if(astarsObject != null && astarsObject.step == 'complete' && astarsShortcut) {
  astarsShortcut.innerHTML = `<a href="/collections/astars-outfitter-results/${astarsObject.results}">
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.15" d="M2.15428 7.67703L14.8377 0.354256L27.5211 7.67703V22.3226L14.8377 29.6453L2.15428 22.3226V7.67703Z" stroke="#D0112B" stroke-width="0.332808"/>
  <path d="M3.43791 8.41903L14.8363 1.83814L26.2348 8.41903V21.5808L14.8363 28.1617L3.43791 21.5808V8.41903Z" fill="#D0112B" stroke="#D0112B" stroke-width="0.332808"/>
  <g clip-path="url(#clip0_603_3949)">
  <path d="M12.221 19.1322C12.1667 18.8765 12.1095 18.6263 12.0637 18.3734C12.0465 18.2789 12.0122 18.2122 11.915 18.1872C11.7005 18.1344 11.6576 18.001 11.6605 17.7925C11.6748 16.9503 11.6662 16.1109 11.6462 15.2632C11.323 16.1471 10.9998 17.0309 10.6738 17.9204C10.1619 17.7369 9.6614 17.5563 9.15234 17.3728C9.22956 17.1282 9.30106 16.8947 9.37541 16.6613C9.94167 14.8824 10.5051 13.1036 11.0742 11.3247C11.1056 11.2247 11.16 11.1302 11.2029 11.0329C11.22 11.0329 11.2372 11.0329 11.2515 11.0301C11.3945 11.3831 11.5375 11.7361 11.6862 12.103C11.7291 12.0946 11.7834 12.0835 11.8492 12.0724C11.8435 11.6305 11.7806 11.1997 11.649 10.7716C12.2096 10.5826 12.7586 10.3936 13.3163 10.2018C13.588 10.7133 13.9741 11.069 14.609 11.0968C14.6662 13.5372 14.7205 15.972 14.7777 18.4123H15.1781C15.2353 15.9775 15.2896 13.5427 15.3468 11.0968C15.6357 11.0829 15.8959 11.0051 16.1247 10.8328C16.3478 10.666 16.5108 10.452 16.6366 10.1963C17.1915 10.3853 17.7463 10.5743 18.3068 10.7661C18.1724 11.1913 18.1152 11.6194 18.1038 12.0613C18.1638 12.0752 18.2182 12.0891 18.2668 12.1002C18.4155 11.7389 18.5585 11.3803 18.7043 11.0246C18.7215 11.0246 18.7358 11.0273 18.753 11.0301C18.793 11.1163 18.8445 11.1997 18.8731 11.2914C19.5108 13.2926 20.1457 15.2966 20.7835 17.2978C20.7892 17.3172 20.792 17.3395 20.8006 17.3728C20.2944 17.5535 19.7939 17.7341 19.282 17.9176C18.956 17.0254 18.6328 16.1415 18.3097 15.2577H18.2897C18.2897 15.2993 18.2897 15.3383 18.2897 15.3772C18.2897 16.236 18.2897 17.0976 18.2897 17.9565C18.2897 18.0315 18.2754 18.0871 18.1924 18.1066C17.9665 18.1649 17.8778 18.315 17.8521 18.5318C17.8292 18.7292 17.7749 18.9265 17.7348 19.1266H12.221V19.1322ZM13.0418 17.4784C13.2248 16.9031 13.4021 16.3416 13.5823 15.7719C13.4708 15.7385 13.3707 15.7107 13.2648 15.6801C13.0132 16.2332 12.7644 16.7752 12.5127 17.3228C12.69 17.3756 12.8587 17.4256 13.0389 17.4812L13.0418 17.4784ZM16.3764 15.7746C16.5566 16.3472 16.7367 16.9086 16.9169 17.4812C17.0971 17.4284 17.2658 17.3756 17.4431 17.3228C17.1886 16.7697 16.9426 16.2277 16.691 15.6773C16.5823 15.7107 16.4822 15.7413 16.3764 15.7746Z" fill="white"/>
  </g>
  <defs>
  <clipPath id="clip0_603_3949">
  <rect width="11.6483" height="8.93035" fill="white" transform="translate(9.15234 10.2021)"/>
  </clipPath>
  </defs>
  </svg>
  </a>`;
}
// Replace filter title

/* if(collectionTemplate) {
  $(document).ready(function () {
    $(function(){
      $("#video-launcher, #video-background, #video-close").click(function () {
      $("#video-content,#video-background").toggleClass("active");
      });
    });
  });
  document.querySelector(".productgrid--sidebar-title").textContent = 'Filter by';
}; */

if (collectionTemplate || searchTemplate) {
  if (collectionTop) {
  	siteMain.insertBefore(breadcrumb, siteMain.childNodes[1]);
  	siteMain.insertBefore(collectionTop, siteMain.childNodes[0]);
  } else {
  	siteMain.insertBefore(breadcrumb, siteMain.childNodes[1]);
  };
};

  // Filter Homepage Collections
$(document).ready(function(){
  $('.featured-filter-option').on('click', function(event){
    event.preventDefault();

    // Handle the filter nav buttons -------------->

    // remove not filtering indicator class if present, and add filtering indicator class
    $(this).removeClass('js-not-filtering').addClass('active-filter');

    // add not filtering class to rest of buttons
    $(this).siblings('.featured-filter-option').removeClass('active-filter').addClass('js-not-filtering');

    // Handle the products to filter -------------->

    // grab the variant title and make it the filter value
    var filteringBy = $(this).text();
    filteringBy = "type-" + filteringBy;

    if(filteringBy == 'type-All') {
      $('.js-type-filter').removeClass('prod-hide');
    } else {
      $('.js-type-filter').each(function() {
        if(!$(this).hasClass(filteringBy)) {
          $(this).addClass('prod-hide');

        } else {
          $(this).removeClass('prod-hide');
          $(this).addClass('active-filter');
        }
      });
    }
    window.dispatchEvent(new Event('resize'));
  }).eq(0).trigger('click');

});

  // Filter products by size
$(document).ready(function(){

  $('.size-filter-option').on('click', function(event){
    event.preventDefault();

    // Handle the filter nav buttons -------------->

    // remove not filtering indicator class if present, and add filtering indicator class
    $(this).removeClass('js-not-filtering').addClass('js-current-filter');

    // add not filtering class to rest of buttons
    $(this).siblings('.size-filter-option').removeClass('js-current-filter').addClass('js-not-filtering');

    // Handle the products to filter -------------->

    // grab the variant title and make it the filter value
    var filteringBy = $(this).text();
    filteringBy = "size-" + filteringBy;

    if(filteringBy == 'size-All') {
      $( "#product-collection" ).addClass('grid-uniform').removeClass('grid');
      $('.js-size-filter').removeClass('prod-hide');
    } else {
      $('.js-size-filter').each(function() {
        if(!$(this).hasClass(filteringBy)) {
          $( ".grid-uniform" ).addClass('grid').removeClass('grid-uniform');
          $(this).addClass('prod-hide');
        } else {
          $(this).removeClass('prod-hide');
          $(this).addClass('active-filter');
        }
      });
    }

  });

});

// Product Specific JS

if(productTemplate) {

// Product Description Toggle

  const productToggle = document.querySelector('.product-description-toggle');

  function descriptionReveal () {
    const productDesc = document.querySelector('.product-description');
    if (productDesc.classList.contains('reveal')) {
      productDesc.classList.remove('reveal');
      productToggle.classList.add('desc-closed');
      productToggle.innerHTML = 'Read more';
    } else {
      productDesc.classList.add('reveal');
      productToggle.classList.remove('desc-closed');
      productToggle.innerHTML = 'Read less';
    }
  };
  if (productToggle) {
    productToggle.addEventListener('click', descriptionReveal);
  };

  // Product Feature Tabs

  let screenWidth = window.innerWidth;
  const descriptionToggle = document.querySelectorAll('.product-info-block-item h4');

  function detectScreenSize() {
    screenWidth = window.innerWidth;
    return screenWidth;
  }
  window.addEventListener('resize', detectScreenSize)

  function handleTab(event) {
    const currentLink = event.currentTarget;
    const nextDiv = currentLink.nextElementSibling;
    if (nextDiv.classList.contains('active')) {
      nextDiv.classList.remove('active');
      currentLink.classList.remove('opened');
    } else {
      nextDiv.classList.add('active');
      currentLink.classList.add('opened')
    }
    
  };

  if (screenWidth <= 1023) {
    descriptionToggle.forEach(title => title.addEventListener('click', handleTab));
  };

  if (screenWidth <= 900) {
    $(".product-info").insertAfter(".product-video");
  };

  $(document).ready(function () {
    $(function(){
      $("#sizing-launcher, #sizing-background, #sizing-close").click(function () {
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        $("#sizing-content,#sizing-background").toggleClass("active");
      });
      $("#shipping-launcher, #shipping-background, #shipping-close").click(function () {
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        $("#shipping-content,#shipping-background").toggleClass("active");
      });
    });
  });

  function openTab(evt, tabName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
  }
  // Get the element with id="defaultOpen" and click on it
  document.querySelector(".tablinks").click();

  $( '.tabcontent p:empty' ).remove();

}; // Product Specific JS End

// Rider Description Toggle

if(athleteTemplate) {

  const riderToggle = document.querySelector('.athlete-description-toggle');

  function riderReveal () {
    const riderDesc = document.querySelector('.more-description');
    if (riderDesc.classList.contains('reveal')) {
      riderDesc.classList.remove('reveal');
      riderToggle.innerHTML = 'Read more';
    } else {
      riderDesc.classList.add('reveal');
      riderToggle.innerHTML = 'Read less';
    }
  };

  riderToggle.addEventListener('click', riderReveal);
  
  $(document).ready(function(){
    $('#play-video').on('click', function(ev) {
        $(this).hide();
        $("#video")[0].src += "?rel=0&autoplay=1";
    });
  });
}

if(homepageTemplate) {

  jQuery(document).ready(function(){
    $("ul.athletes").each(function(){
         $(this).hide();
        if($(this).attr('id') == 'road-athletes') {
            $(this).show();
        }
    });


    $('a.athlete-nav').on( "click", function(e) {
        e.preventDefault();
        $('a.athlete-nav').removeClass('active');
        $(this).addClass('active');
        var id = $(this).attr('data-athlete-class'); 
        $("ul.athletes").each(function(){
            $(this).hide();
            if($(this).attr('id') == id) {
                $(this).show();
            }
        });
    });
  });
}
if (pageTemplate) {
  jQuery(document).ready(function(){
      $("select").change(function(){
          $(this).find("option:selected").each(function(){
              var optionValue = $(this).attr("value");
              if(optionValue){
                  $(".athlete-container").not("." + optionValue).hide();
                  $("." + optionValue).show();
              } else{
                  $(".athlete-container").show();
              }
          });
      }).change();
  });
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
